import React from "react";
import cx from "classnames";

import styles from "./VitalSign.module.css";
import InputField from "../InputField";

export default function VitalSign({
  title = "Tanda Vital",
  description = "Input tanda-tanda vital dan parameter pemantauan pasien",
  lastUpdateLabel = "Terakhir Update",
  lastUpdateTime,
  iconColor = "#09BD3C",
  isView = false,
  formData = {
    beratBadan: "",
    tinggiBadan: "",
    suhu: "",
    satOksigen: "",
    tds: "",
    tdd: "",
    frekuensiPernapasan: "",
    frekuensiNadi: "",
    updatedAt: "",
  },
  onChange = () => {},
}) {
  const handleInputChange = (key, value) => {
    onChange(key, value);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.titleSection}>
          <div className={styles.titleRow}>
            <i
              className={cx("fas fa-heartbeat", styles.icon)}
              style={{ color: iconColor }}
            />
            <p className={styles.title}>{title}</p>
          </div>
          <p className={styles.description}>{description}</p>
        </div>

        {lastUpdateTime && (
          <div className={styles.updateSection}>
            <p className={styles.updateLabel}>{lastUpdateLabel}</p>
            <p className={styles.updateTime}>{lastUpdateTime}</p>
          </div>
        )}
      </div>

      <hr className={styles.divider} />

      <div className={styles.content}>
        <div className={styles.row}>
          <div className={styles.section}>
            <div className={styles.sectionHeader}>
              <i
                className={cx(
                  "fas fa-weight",
                  styles.sectionIcon,
                  styles.iconPengukuran
                )}
              />
              <p className={styles.sectionTitle}>Pengukuran Tubuh</p>
            </div>

            <InputField
              label="Berat Badan"
              placeholder="0"
              value={formData.beratBadan}
              onChange={(value) => handleInputChange("beratBadan", value)}
              suffix="Kg"
              type="number"
              size="small"
              disabled={isView}
            />
            <InputField
              label="Tinggi Badan"
              placeholder="0"
              value={formData.tinggiBadan}
              onChange={(value) => handleInputChange("tinggiBadan", value)}
              suffix="Cm"
              type="number"
              size="small"
              disabled={isView}
            />
          </div>

          {/* Tanda Vital Section */}
          <div className={styles.section}>
            <div className={styles.sectionHeader}>
              <i
                className={cx(
                  "fas fa-heartbeat",
                  styles.sectionIcon,
                  styles.iconTandaVital
                )}
              />
              <p className={styles.sectionTitle}>Tanda Vital</p>
            </div>

            <InputField
              label="TDs (Sistolik)"
              placeholder="0"
              value={formData.tds}
              onChange={(value) => handleInputChange("tds", value)}
              suffix="mmHg"
              type="number"
              size="small"
              disabled={isView}
            />

            <InputField
              label="TDd (Diastolik)"
              placeholder="0"
              value={formData.tdd}
              onChange={(value) => handleInputChange("tdd", value)}
              suffix="mmHg"
              type="number"
              size="small"
              disabled={isView}
            />
          </div>
        </div>

        <div className={styles.row}>
          {/* Suhu & Oksigen Section */}
          <div className={styles.section}>
            <div className={styles.sectionHeader}>
              <i
                className={cx(
                  "fas fa-thermometer-half",
                  styles.sectionIcon,
                  styles.iconSuhuOksigen
                )}
              />
              <p className={styles.sectionTitle}>Suhu & Oksigen</p>
            </div>

            <InputField
              label="Suhu"
              placeholder="0"
              value={formData.suhu}
              onChange={(value) => handleInputChange("suhu", value)}
              suffix="°C"
              type="number"
              size="small"
              disabled={isView}
            />

            <InputField
              label="Sat (Saturasi)"
              placeholder="0"
              value={formData.satOksigen}
              onChange={(value) => handleInputChange("satOksigen", value)}
              suffix="%"
              type="number"
              size="small"
              disabled={isView}
            />
          </div>

          {/* Frekuensi Section */}
          <div className={styles.section}>
            <div className={styles.sectionHeader}>
              <i
                className={cx(
                  "fas fa-wave-square",
                  styles.sectionIcon,
                  styles.iconFrekuensi
                )}
              />
              <p className={styles.sectionTitle}>Frekuensi</p>
            </div>

            <InputField
              label="Fp (Frek. Pernapasan)"
              placeholder="0"
              value={formData.frekuensiPernapasan}
              onChange={(value) =>
                handleInputChange("frekuensiPernapasan", value)
              }
              suffix="x/min"
              type="number"
              size="small"
              disabled={isView}
            />

            <InputField
              label="Fn (Frek. Nadi)"
              placeholder="0"
              value={formData.frekuensiNadi}
              onChange={(value) => handleInputChange("frekuensiNadi", value)}
              suffix="x/min"
              type="number"
              size="small"
              disabled={isView}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
